/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useState } from 'react';
import { Icon, Button, Text, Stack, useId } from 'sarsaparilla';

export function OrderDetailsTimerNotice({ ...props }) {
    const [isExpanded, setExpanded] = useState(false);
    const computedId = useId();

    const handleButtonClick = () => {
        setExpanded((prev) => !prev);
    };

    return (
        <div
            data-component="OrderDetailsTimerNotice"
            role="alert"
            aria-live="assertive"
            {...props}
        >
            <Stack space="xs">
                <div className="shared-title-group">
                    <Icon iconName="clock" size="md" />
                    <Text tag="span" fontWeight="semibold">
                        You have 15 minutes to complete the order details for this
                        reservation.
                    </Text>
                    <Button
                        className="shared-read-more-button"
                        size="xs"
                        appearance="link"
                        aria-controls={computedId}
                        aria-label="Show Details"
                        aria-expanded={isExpanded}
                        onClick={handleButtonClick}
                    >
                        {isExpanded && (
                            <span className="shared-read-more-with-icon">
                                <span>Hide Details</span>{' '}
                                <Icon iconName="chevron-up" size="sm" />
                            </span>
                        )}
                        {!isExpanded && (
                            <span className="shared-read-more-with-icon">
                                <span>Show Details</span>{' '}
                                <Icon iconName="chevron-down" size="sm" />
                            </span>
                        )}
                    </Button>
                </div>

                {isExpanded && (
                    <Text className="shared-timer-notice-details">
                        When time is about to expire, you’ll have the opportunity to add
                        an additional five minutes. However, once that time is up, this
                        order will be removed from your cart and made available to other
                        visitors
                    </Text>
                )}
            </Stack>
        </div>
    );
}
